/**
 * Formats a number to a string with 2 decimal places, a comma decimal separator,
 * and spaces for thousands separators.
 * A more descriptive name could be `formatDecimalWithThousandsSeparator`.
 * Throws an error for non-numeric inputs.
 *
 * @param value The number or string to format.
 * @returns A formatted string.
 */
export const formatAsPrice = (value: number | string): string => {
  if (value === null || value === undefined) {
    return '';
  }

  const stringValue = String(value).replace(',', '.').trim();

  if (stringValue === '') {
    return '';
  }

  const numberValue = parseFloat(stringValue);

  if (isNaN(numberValue)) {
    return '';
  }

  const fixedString = numberValue.toFixed(2).toString();
  const parts = fixedString.split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const formattedNumber =
    parts.length > 1 ? integerPart + ',' + parts[1] : integerPart;

  return formattedNumber;
};
